// const AJAX_URL = '/wp-admin/admin-ajax.php'

jQuery(document).foundation()
jQuery(document).ready(function($) {
    joints_wp_fixes()
    // AOS.init()  //Enable if loading AOS

  //Smooth Scroll
  $('a[href*="#"]:not([role="tab"]):not(.skip-anchor)').on("click", function() {
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        $("html, body").animate(
          {
            scrollTop: target.offset().top - 125
          },
          1000
        );
        return false;
      }
    }
  });
  //Smooth Scroll on page load if hash
  var hash = window.location.hash;
  if (hash) {
    var target = $(hash);
    target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
    if (target.length) {
      $("html, body").animate(
        {
          scrollTop: target.offset().top - 125
        },
        1000
      );
      return false;
    }
  }

    registerAchievementsSlider($)
    registerGallerySlider($)

    if ($('.gfield_radio')) {
        $('.gfield_radio').each(function() {
            $(this)
                .find('label')
                .each(function() {
                    $(this).on('click', function() {
                        $(this)
                            .find('input[type="radio"]')
                            .click()
                    })
                })
        })
    }

    // Checks viewport
    $.fn.isOnScreen = function() {
        var win = $(window)

        var viewport = {
            top: win.scrollTop(),
            left: win.scrollLeft(),
        }
        viewport.right = viewport.left + win.width()
        viewport.bottom = viewport.top + win.height()

        var bounds = this.offset()
        bounds.right = bounds.left + this.outerWidth()
        bounds.bottom = bounds.top + this.outerHeight()

        return !(
            viewport.right < bounds.left ||
            viewport.left > bounds.right ||
            viewport.bottom < bounds.top ||
            viewport.top > bounds.bottom
        )
    }

    if ($('.counter').length > 0) {
        var onScreen = 0
        $(window).scroll(function() {
            if ($('.counter').isOnScreen()) {
                onScreen++
                if (onScreen === 1) {
                    $('.counter').each(function() {
                        var endNum = this.getAttribute('data-count')
                        var numAnim = new CountUp(this, 0, endNum)
                        if (!numAnim.error) {
                            numAnim.start()
                        } else {
                            console.error(numAnim.error)
                        }
                    })
                }
            } else {
                // onScreen = 0;
            }
        })
    }

    if ($('.blog-container').length > 0) {
        $(function() {
            $('.blog-container').matchHeight()
        })
    }
})

function registerAchievementsSlider($) {
    const $slider = $('.achievement-slider')

    if ($slider.length > 0) {
        $slider.slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                    },
                },
            ],
        })
    }
}

function registerGallerySlider($) {
    const $slider = $('.gallery-container')

    if ($slider.length > 0) {
        $slider.slick({
            centerMode: true,
            centerPadding: '175px',
            infinite: true,
            speed: '800',
            appendArrows: $('.gallery-arrows'),
            prevArrow: $('.arrow-prev'),
            nextArrow: $('.arrow-next'),
            draggable: false,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        centerMode: false,
                        slidesToShow: 1,
                        speed: '500',
                    },
                },
            ],
        })
    }
}
